module.exports = __webpack_public_path__ + "static/media/solana.49c97441.png";